import {useState} from "react";
import styles from "../EventSubmissionFormV2/EventSubmissionFormV2.module.scss";
import i18n from "../../i18n";
import PropTypes from "prop-types";

import {Submit} from "./EventSubmissionFormV2";
import {getSelectedCategories} from "./SummationStep";
import Loader from "../Loader";

const SuccessStep = ({formValues, categories, onSubmit}) => {
    const [isLoading, setIsLoading] = useState(false);

    const {
        titleEn,
        descriptionEn,
        categories: categoriesInLocalStorage,
        imageBase64,
    } = formValues;

    const selectedCategories = getSelectedCategories(categories, categoriesInLocalStorage)

    const handleClick = () => {
        setIsLoading(true)
        onSubmit()
    }

    return (

        <>
            <div className={styles['EventSubmissionFormV2__Confirmation']}>
                {imageBase64 &&
                    <div className={styles['EventSubmissionFormV2__ImageWrapper']}>
                        <img className={styles['EventSubmissionFormV2__Image']} id="preview"
                             src={imageBase64} alt=""/>
                    </div>
                }
                <div className={styles['EventSubmissionFormV2__TextWrapper']}>
                    <h2 className={styles['EventSubmissionFormV2__EventTitle']}>{titleEn}</h2>
                    {!!selectedCategories?.length &&
                        <p className={styles['EventSubmissionFormV2__EventLabel']}
                            dangerouslySetInnerHTML={{
                                __html: selectedCategories.join(' &bull; '),
                            }}
                        />
                    }
                    <p className={styles['EventSubmissionFormV2__EventDescription']}>{descriptionEn}</p>
                </div>
            </div>
            {!!isLoading ? (
                <Loader position="left"/>
            ) : (
                <Submit text={i18n.t('EventSubmissionFormV2.buttons.startAgain')} onClick={handleClick}/>
            )}
        </>
    )
}

export default SuccessStep;
